import { useTheme } from 'next-themes'
import { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

interface SkeletonProviderProps {
    children: React.ReactNode
}

export function SkeletonProvider({ children }: SkeletonProviderProps) {
    const { resolvedTheme } = useTheme()
    const isDark = resolvedTheme === 'dark'

    // Use consistent values that will work in SSR
    // Default to light theme colors for initial SSR render
    const baseColor = isDark ? 'rgba(55, 65, 81, 0.5)' : '#f0f0f0'
    const highlightColor = isDark ? 'rgba(75, 85, 99, 0.5)' : '#f8f8f8'

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            {children}
        </SkeletonTheme>
    )
}
